import React from 'react';
import PropTypes from 'prop-types';
import Case from 'case';
import { Box, Text, Button } from 'grommet';
import { useAppTheme } from '@Components/Context';
import { SimpleModal } from '@Components/Control';

const DynamicDetailsModal = ({
  small,
  label,
  details = null,
  children = null,
  tableButtonStyle = false,
}) => {
  const [showModal, setShowModal] = React.useState(false);
  const { theme } = useAppTheme();
  const { page, button } = theme;

  if ((!details || typeof details !== 'object') && !children) return <Text color={page.tableText}>—</Text>;

  const renderModalContents = () => {
    if (children) {
      return children;
    }

    return (
      <Box direction="column" gap="0.5rem">
        {Object.entries(details).map(([key, value]) => (
          <Box key={key} direction="row" gap="0.5rem" align="center">
            <Text color={page.modalText} weight={500}>
              {Case.title(key)}
              :
            </Text>
            <Text color={page.modalText}>
              {typeof value === 'object' ? JSON.stringify(value) : String(value)}
            </Text>
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Box>
      <Button
        plain
        style={tableButtonStyle ? {
          textAlign: 'start',
          backgroundColor: button.tableBg,
          borderRadius: '6px',
          padding: small ? '0.35rem 0.6rem' : '0.25rem 0.5rem',
          width: 'fit-content',
          border: 'none',
          cursor: 'pointer',
        } : {
          color: page.highlight,
          fontWeight: 600,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
        }}
        onClick={() => setShowModal(true)}
      >
        {tableButtonStyle ? (
          <Text size={small ? '1rem' : '0.9rem'} weight={500} color={button.tableText}>
            {label}
          </Text>
        ) : (
          <Text color={page.highlight} size="1rem" weight={500}>
            View
            {' '}
            {label}
          </Text>
        )}
      </Button>
      {showModal && (
        <SimpleModal
          hideLowerSection
          small={small}
          toggleModal={setShowModal}
          modalTitle={label}
          textColor={page.modalText}
          highlightColor={page.highlight}
          modalBg={page.modalBg}
          titleSize="1.1rem"
          desktopMinWidth="22rem"
        >
          <Box direction="column" gap="0.5rem" pad={{ vertical: '0.5rem' }}>
            {renderModalContents()}
          </Box>
        </SimpleModal>
      )}
    </Box>
  );
};

DynamicDetailsModal.propTypes = {
  small: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  details: PropTypes.object,
  children: PropTypes.node,
  tableButtonStyle: PropTypes.bool,
};

export default DynamicDetailsModal;
